import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Waves_ds_open_waves_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerId?: number, projectIds?: number, statusIds?: number[], warehouseId?: number }): 
  Promise<{ result: { WaveCount?: number, Status?: { Id?: number, Name?: string }, StatusName?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Waves/datasources/ds_open_waves_widget/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerId?: number, projectIds?: number, statusIds?: number[], warehouseId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { WaveCount?: number, Status?: { Id?: number, Name?: string }, StatusName?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Waves/datasources/ds_open_waves_widget/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerId?: number, projectIds?: number, statusIds?: number[], warehouseId?: number, $keys: { Status?: { Id?: number, Name?: string } }[] }): 
  Promise<{ result: { WaveCount?: number, Status?: { Id?: number, Name?: string }, StatusName?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Waves/datasources/ds_open_waves_widget/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerId?: number, projectIds?: number, statusIds?: number[], warehouseId?: number    }) {
      return false;
    }
}
